export enum EditAction {
    CUSTOM = "custom",
    TRANSLATE = "translate",
    CONCISE = "concise",
    DETAILED = "detailed",
}
